import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumChangeLogLineType implements BaseEnumType {
  private static allValues: EnumChangeLogLineType[] = []; // make sure this is top-most
  
  public static unknown = new EnumChangeLogLineType(0, "Unknown", "enum_change_log_line_type_unknown");
  public static fieldChange = new EnumChangeLogLineType(1, "FieldChange", "enum_change_log_line_type_field_change");
  public static add = new EnumChangeLogLineType(2, "Add", "enum_change_log_line_type_add");
  public static remove = new EnumChangeLogLineType(3, "Remove", "enum_change_log_line_type_remove");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumChangeLogLineType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumChangeLogLineType.unknown; }
  public isFieldChange() { return this === EnumChangeLogLineType.fieldChange; }
  public isAdd() { return this === EnumChangeLogLineType.add; }
  public isRemove() { return this === EnumChangeLogLineType.remove; }

  public static getValues(): readonly EnumChangeLogLineType[] {
    return EnumChangeLogLineType.allValues;
  }

  public static getValuesExcept0(): readonly EnumChangeLogLineType[] {
    return EnumChangeLogLineType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumChangeLogLineType {
    const found = EnumChangeLogLineType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumChangeLogLineType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumChangeLogLineType): EnumChangeLogLineType {
    const found = name ? EnumChangeLogLineType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumChangeLogLineType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumChangeLogLineType>): boolean {
    return this.key === other?.key;
  }
}